import { Button } from '@/components/ui/button';
import { AlertCircleIcon } from 'lucide-react';

interface LandingsErrorStateProps {
	message?: string;
	onRetry: () => void;
}

export default function LandingsErrorState({
	message = 'Не удалось загрузить данные',
	onRetry,
}: LandingsErrorStateProps) {
	return (
		<div className='flex flex-col items-center gap-3 py-8 text-center'>
			<div className='rounded-full bg-destructive/10 p-3'>
				<AlertCircleIcon size={24} className='text-destructive' />
			</div>
			<p className='text-sm text-muted-foreground max-w-[280px]'>{message}</p>
			<Button type='button' variant='outline' size='sm' onClick={onRetry}>
				Повторить
			</Button>
		</div>
	);
}
